import React, { Component } from 'react';
import { View, Text } from 'react-native';
import utils from '../utils';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning'
};

const appActionMap: { [propName: string]: boolean } = {
    pay: true
};

interface Props {
    data: {
        orderType: string;
        productTitle: string;
        activityTimeInfo: string;
        createTimeInfo: string;
        fromDate: string;
        toDate: string;
        _disable: boolean;
    };
}

class Huiyi extends Component {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // icon
        newData.iconfont = '\uf177';
        newData.iconColor = '#3799f0';
        // 价格按钮等
        if (newData.orderType === 14001002) {
            newData.currency = (newData.currency || '').trim();
            newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
            newData.activityTimeInfo =
                Boolean(newData.fromDate && newData.days) &&
                `活动时间  ${formatDateAsNumAndChinese(newData.fromDate)}开始 ${newData.days}天`;
        } else {
            newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
            newData.productTitle = buildProductTitle(newData);
            newData.currency = '';
        }

        newData.createTimeInfo =
            newData.createTime && `下单时间  ${utils.buildDateTime(newData.createTime)}`;
        return newData;
    };

    public render() {
        const {
            data: {
                orderType,
                productTitle,
                activityTimeInfo,
                createTimeInfo,
                fromDate,
                toDate,
                _disable
            } = {}
        } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        return (
            <View style={styles.left}>
                <Text style={styles.newOrderTitle} numberOfLines={2}>
                    {productTitle}
                </Text>
                {orderType === 14001002 ? (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {activityTimeInfo}
                    </Text>
                ) : fromDate && toDate ? (
                    <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                        {`${fromDate} 至 ${toDate}`}
                    </Text>
                ) : null}
                <Text style={styles.newOrderSubTitle} numberOfLines={1}>
                    {createTimeInfo}
                </Text>
            </View>
        );
    }
}

const buildProductTitle = (data?: {
    productTitle: string;
    personCount: number;
    days: number;
    city: string;
}) => {
    const result = [];
    if (data) {
        data.productTitle && result.push(data.productTitle);
        data.personCount && result.push(`${data.personCount}人`);
        data.days && result.push(`${data.days}天`);
        data.city && result.push(data.city);
    }
    return result.join(' ');
};

function formatDateAsNumAndChinese(dateStr: string) {
    const datas: string[] = dateStr.split('-');
    const date = new Date(Number(datas[0]), Number(datas[1]) - 1, Number(datas[2]));
    return [date.getFullYear(), '年', date.getMonth() + 1, '月', date.getDate(), '日'].join('');
}

export default Huiyi;
